import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Box, Typography } from "@mui/material";
import { Progress } from "antd";
import React, { useEffect } from "react";
import styled from "styled-components";
import api from "../../../services/api";
import {
  laranjaMain,
  laranjaSecundarioTransp,
  profileWhiteShade,
} from "../../../utils/styledVariables";
import levelStar from "../../../assets/LevelStar.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const Card = styled(Box)`
  background-color: ${laranjaMain};
  border-radius: 12px;
  padding: 16px;
  width: 260px;
  height: 120px;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  @media (max-width: 768px) {
    width: 140px;
    height: 90px;
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const XP = styled.span`
  font-size: 25px;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const StarWrapper = styled.div`
  background-color: white;
  color: #f97338; // laranja Oxetech
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

const Nivel = styled.div`
  font-size: 22px;
  font-weight: 600;
  margin-top: 4px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export default function NivelPerfil() {
  const [percentage, setPercentage] = React.useState(30);
  const [infoAluno, setInfoAluno] = React.useState([]);
  const [label, setLabel] = React.useState("Iniciante");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    api.get("aluno/profile").then((response) => {
      setInfoAluno(response.data);
    });
  }, []);

  const handleProgressBar = () => {
    const itemPoints = {
      linkedin: 1,
      github: 1,
      experiences: {
        professional: 20,
        certification: 8,
        education: 20,
      },
      languages: 10,
      skills: 10,
    };
    let points = 0;
    let fieldsFilled = [];

    if (infoAluno.linkedin) {
      points += itemPoints.linkedin;
      fieldsFilled.push("linkedin");
    }
    if (infoAluno.github) {
      points += itemPoints.github;
      fieldsFilled.push("github");
    }

    if (infoAluno.experiences) {
      infoAluno.experiences.forEach((exp) => {
        const expPoints = itemPoints.experiences[exp.experience_type];
        if (expPoints && !fieldsFilled.includes(exp.experience_type)) {
          points += expPoints;
          fieldsFilled.push(exp.experience_type);
        }
      });
    }

    if (infoAluno.languages) {
      points += itemPoints.languages;
      fieldsFilled.push("languages");
    }
    if (infoAluno.skills) {
      points += itemPoints.skills;
      fieldsFilled.push("skills");
    }

    const maxPoints = Object.values(itemPoints).reduce(
      (acc, points) =>
        acc +
        (typeof points === "object"
          ? Object.values(points).reduce((a, p) => a + p, 0)
          : points),
      0
    );

    const calculated = Math.floor((points / maxPoints) * 100);

    let label;
    if (calculated <= 50) {
      label = "Iniciante";
    } else if (calculated > 50 && calculated <= 70) {
      label = "Intermediário";
    } else if (calculated > 70 && calculated <= 99) {
      label = "Avançado";
    } else if (calculated === 100) {
      label = "Campeão";
    }

    setLabel(label);
    setPercentage(calculated);
    return label;
  };

  useEffect(() => {
    handleProgressBar();
  }, [infoAluno]);

  return (
    <Card>
      <div>
        <Typography variant="caption">Nível de Perfil</Typography>
        <Nivel>{label}</Nivel>

        <Top>
          <XP>{percentage * 10}xp</XP>
        </Top>
      </div>

      <img
        src={levelStar}
        alt="Nível"
        style={{
          width: isMobile ? 70 : 100,
          height: isMobile ? 70 : 100,
          objectFit: "contain",
          marginLeft: "auto",
        }}
      />
    </Card>
  );
}
